<template>
  <q-dialog
    ref="jtCompositionModal"
    @show="onShowHandler"
    @hide="onHideHandler"
  >
    <q-layout view="Lhh lpR fff" container class="bg-white modal-large">
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>
            <q-icon name="edit" size="25px" />
            {{ $gettext(computedTitle) }}
          </q-toolbar-title>
          <q-btn flat @click="hide">
            <q-icon name="cancel" size="2.5em"/>
          </q-btn>
        </q-toolbar>
      </q-header>
      <span v-for="(item, index) in listFroms" :key="index">
        <jt-dynamic-form
          v-if="renderForm"
          :ref="`compositionForm-${index}`"
          :inputs="form.inputs"
          :interface="form.nmInterface"
          :relacionamentos="form.relacionamentos"
          :model="item"
          form-class="form"
          class="q-pa-lg q-mt-xl"
        />
      </span>
      <q-btn
        class="bg-blue-grey text-white full-height self-center q-py-xs"
        icon="add"
        @click="residueAdd"
      ></q-btn>
      <section
        class="row justify-center full-width q-gutter-md q-pa-lg sectionContactPerson"
      >
        <div
          v-for="(button, index) in form.buttons"
          :key="index"
          class="col-2 buttonsContactPerson"
        >
          <q-btn
            class="full-width"
            color="blue-grey"
            :name="button.name"
            @click="onFormButtonClickHandler({ button })"
            >{{ button.label }}
          </q-btn>
        </div>
      </section>
    </q-layout>
  </q-dialog>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCompositionFormModal, JtDynamicForm } from 'jtech-webcomps'
import {
  QDialog,
  QLayout,
  QIcon,
  QToolbar,
  QToolbarTitle,
  QHeader,
  QBtn
} from 'quasar'
@Component({
  mixins: [JtCompositionFormModal],
  name: 'ResidueGenerator',
  components: {
    JtDynamicForm,
    QDialog,
    QLayout,
    QIcon,
    QToolbar,
    QHeader,
    QToolbarTitle,
    QBtn
  }
})
class ResidueGeneretor extends Vue {
  listFroms = [];

  show () {
    this.listFroms = []
    this.residueAdd()
    this.$refs.jtCompositionModal.show()
  }

  residueAdd () {
    this.listFroms.push({ ...this.form.dadosForm })
  }

  onFormButtonClickHandler (formButton) {
    if (formButton.button.name === 'btSalvarComposicao') {
      this.__saveButtonHandler(formButton)
    } else {
      this.listFroms = []
      this.residueAdd()
    }
  }

  __saveButtonHandler (formInfo) {
    try {
      let valid = true
      this.listFroms.forEach((item, index) => {
        if (this.$refs[`compositionForm-${index}`][0].isValidForm() === false) {
          valid = false
        }
      })
      if (!valid) return
      const dadosGrids = []
      this.listFroms.forEach(async (item, index) => {
        // eslint-disable-next-line no-async-promise-executor
        const dadosGrid = new Promise(async (resolve, reject) => {
          try {
            const { nmInterface } = this.form
            const {
              data: { dadosGrid }
            } = await this.$jt.repository.manterComponente(nmInterface, {
              method: 'salvarComposicao',
              composicaos: this.composicaos,
              flComposicaoAlteracao: this.flComposicaoAlteracao,
              ...item,
              available: true,
              nrLinhaSelecionada: this.nrLinhaSelecionada
            })
            resolve(dadosGrid)
          } catch (e) {
            reject(e)
          }
        })
        dadosGrids.push(await dadosGrid)
        if (dadosGrids.length === this.listFroms.length) {
          this.finalySave(dadosGrids, formInfo.button)
        }
      })
    } catch (error) {
      console.error('__saveButtonHandler', error)
    }
  }

  finalySave (dadosGrids, button) {
    dadosGrids.forEach((dadosGrid, index) => {
      const eventId = this.flComposicaoAlteracao
        ? 'onEditSuccess'
        : 'onAddSuccess'
      dadosGrid.flAlterado = this.flComposicaoAlteracao ? 'S' : 'N'
      dadosGrid.nrLinhaSelecionada = this.nrLinhaSelecionada
      this.$emit(eventId, dadosGrid, button)
    })
  }
}
export default ResidueGeneretor
</script>
<style lang="stylus" scoped>
.composition-multi-form-modal .containerForm-add #scroll-area {
    height: calc(15vh - 12px) !important;
}
</style>
